import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Pencil, Trash2, X, MoreVertical } from "lucide-react";

const TaskListsSection = ({
    isOpen,
    lists,
    activeListId,
    setActiveListId,
    onCreateClick,
    onEditClick,
    onDeleteList,
}) => (
    <AnimatePresence>
        {isOpen && (
            <motion.div
                initial={{ opacity: 0, height: 0 }}
                animate={{ opacity: 1, height: "auto" }}
                exit={{ opacity: 0, height: 0 }}
                className="p-2 bg-surface shadow-sm rounded-xl mt-4 border border-line"
            >
                <div className="flex items-center justify-between mb-2 pb-2 border-b border-line">
                    <h2 className="text-md font-semibold text-ink">Lists</h2>
                    <button
                        type="button"
                        onClick={onCreateClick}
                        className="flex items-center gap-2 text-primary cursor-pointer mr-1 font-semibold text-sm hover:underline"
                    >
                        Create new list
                    </button>
                </div>
                <div className="flex gap-4 overflow-x-auto pb-2 scrollbar-hide">
                    {lists.map((list) => (
                        <div
                            key={list.id}
                            className="flex items-center gap-2 px-3 py-2 bg-surface-2 shadow-sm rounded-full whitespace-nowrap hover:shadow-md transition border border-line"
                        >
                            <div className="flex items-center gap-2">
                                <div
                                    className="w-6 h-6 rounded-full shrink-0"
                                    style={{ backgroundColor: list.list_color }}
                                />
                                <span className="text-sm font-medium text-ink">
                                    {list.list_name}
                                </span>
                            </div>
                            <AnimatePresence>
                                {activeListId === list.id && (
                                    <motion.div
                                        initial={{ opacity: 0, x: 10 }}
                                        animate={{ opacity: 1, x: 0 }}
                                        exit={{ opacity: 0, x: 10 }}
                                        className="flex items-center gap-2 ml-3"
                                    >
                                        <button
                                            type="button"
                                            onClick={() => onEditClick(list)}
                                            className="flex items-center gap-1 px-2 py-1 text-sm text-ink-secondary bg-surface-3 rounded-lg hover:bg-surface transition"
                                        >
                                            <Pencil className="w-4 h-4" /> Edit
                                        </button>
                                        <button
                                            type="button"
                                            onClick={() => onDeleteList(list.id)}
                                            className="flex items-center gap-1 px-2 py-1 text-sm text-error bg-error/10 rounded-lg hover:bg-error/20 transition"
                                        >
                                            <Trash2 className="w-4 h-4" /> Delete
                                        </button>
                                    </motion.div>
                                )}
                            </AnimatePresence>
                            <button
                                type="button"
                                className="p-1 rounded-full hover:bg-surface-3"
                                onClick={() =>
                                    setActiveListId((prev) =>
                                        prev === list.id ? null : list.id
                                    )
                                }
                            >
                                {activeListId === list.id ? (
                                    <X className="w-4 h-4 text-ink-secondary" />
                                ) : (
                                    <MoreVertical className="w-4 h-4 text-ink-secondary" />
                                )}
                            </button>
                        </div>
                    ))}
                </div>
            </motion.div>
        )}
    </AnimatePresence>
);

export default TaskListsSection;
